import currentWidgetDetails from "utilities/platform/widget-details";

















class SpartaInputAdaUtility {


  init(fields) {


    let self = this;


    fields.forEach((element) => {
      let _field = element;
      let _fieldType = _field.classList.contains('spa-input-box') ? 'inputSingle' : 'checkboxGroup';
      let _wrapper = _fieldType == 'inputSingle' ? _field : _field.parentNode;


      if (_fieldType === 'inputSingle') {
        _field = _field.querySelector('input, select, textarea');
      }


      const _label = _wrapper.querySelector('label') || null;

      window.onload = function () {
        let _inputID = _field.getAttribute('id') || null;


        const helpLink = _wrapper.querySelector(`#help-open-${_inputID}`) || null;
        const helpLinkString = helpLink ? `help-open-${_inputID}` : ``;

        const helpLayer = _wrapper.querySelector(`#helpLayer_${_inputID}`) || null;
        const helpLayerString = helpLayer ? `helpLayer_${_inputID} ` : ``;

        const hintText = _wrapper.querySelector(`#${_inputID}-hint-text`) || null;
        const hintTextString = hintText ? `${_inputID}-hint-text ` : ``;

        const error = _wrapper.querySelector(`#${_inputID}_errorMessage`) || null;
        const errorString = error ? `${_inputID}_errorMessage ` : ``;



        let groupHelpLinkString = '';
        let groupHelpLayerString = '';
        let groupHintTextString = '';
        let groupErrorString = '';
        if (_fieldType === 'checkboxGroup') {

          let groupSiblings = 0;
          if (self._getClosest(_wrapper, '.spa-input-options-list')) {
            groupSiblings = self._getClosest(_wrapper, '.spa-input-options-list').children.length;
          }


          if (groupSiblings <= 1) return;


          let groupWrapper = self._getClosest(_wrapper, 'fieldset');
          let groupID = groupWrapper.getAttribute('id') || null;
          let groupLabel = groupWrapper.querySelector('legend');


          let groupHelpLink = groupWrapper.querySelector(`#help-open-${groupID}`);
          groupHelpLinkString = groupHelpLink ? `help-open-${groupID} ` : ``;

          let groupHelpLayer = groupWrapper.querySelector(`#helpLayer_${groupID}`);
          groupHelpLayerString = groupHelpLayer ? `helpLayer_${groupID} ` : ``;

          let groupHintText = groupWrapper.querySelector(`#${groupID}-hint-text`);
          groupHintTextString = groupHintText ? `${groupID}-hint-text ` : ``;

          let groupError = groupWrapper.querySelector(`#${groupID}_errorMessage`);
          groupErrorString = groupError ? `${groupID}_errorMessage ` : ``;
        };



        let setHintString = hintTextString + (groupHintTextString && groupHintTextString.length ? groupHintTextString : ``);
        let setHelpLayerString = helpLayerString + (groupHelpLayerString ? groupHelpLayerString : ``);
        let string = `${setHintString}${setHelpLayerString}`;


        if (string.length >= 1) {
          _field.setAttribute('aria-describedby', string);
        }
      };
    });
  } 






  _getClosest(elem, selector) {

    if (!Element.prototype.matches) {
      Element.prototype.matches =
        Element.prototype.matchesSelector ||
        Element.prototype.mozMatchesSelector ||
        Element.prototype.msMatchesSelector ||
        Element.prototype.oMatchesSelector ||
        Element.prototype.webkitMatchesSelector ||
        function (s) {
          var matches = (document || ownerDocument).querySelectorAll(s),
            i = matches.length;
          while (--i >= 0 && matches.item(i) !== this) {
          }
          return i > -1;
        };
    }


    for (; elem && elem !== document; elem = elem.parentNode) {
      if (elem.matches(selector)) return elem;
    }
    return null;
  };

}; 


export default new SpartaInputAdaUtility();